import React from 'react';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gmax-dark-blue text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Sobre Nós</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Conheça a GMAX Soluções e nossa missão de oferecer serviços de facilities de excelência.
          </p>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center gap-12">
            <div className="md:w-1/2">
              <h2 className="section-title">Nossa História</h2>
              <p className="text-gray-600 mb-6">
                A GMAX Soluções nasceu da percepção de que empresas precisam focar em seu core business, 
                delegando serviços de facilities a parceiros confiáveis e eficientes.
              </p>
              <p className="text-gray-600 mb-6">
                Com anos de experiência no mercado, construímos um amplo banco de dados de profissionais 
                qualificados em diversas cidades do Brasil, permitindo atendimento rápido e eficaz para 
                qualquer necessidade de facilities.
              </p>
              <p className="text-gray-600">
                Nosso compromisso é oferecer serviços de alta qualidade com preços competitivos, 
                garantindo a satisfação dos nossos clientes e o sucesso de seus negócios.
              </p>
            </div>
            <div className="md:w-1/2">
              <div className="bg-gray-100 p-8 rounded-lg">
                <h3 className="text-2xl font-bold mb-4 text-gmax-dark-blue">Nossa Missão</h3>
                <p className="text-gray-600 mb-6">
                  Proporcionar soluções completas em facilities, permitindo que nossos clientes 
                  concentrem seus recursos e esforços em suas atividades principais.
                </p>
                
                <h3 className="text-2xl font-bold mb-4 text-gmax-dark-blue">Nossa Visão</h3>
                <p className="text-gray-600 mb-6">
                  Ser reconhecida como referência nacional em serviços terceirizados de facilities, 
                  destacando-se pela qualidade, agilidade e compromisso com os resultados.
                </p>
                
                <h3 className="text-2xl font-bold mb-4 text-gmax-dark-blue">Nossos Valores</h3>
                <ul className="text-gray-600 space-y-2">
                  <li>• Excelência em serviços</li>
                  <li>• Compromisso com prazos</li>
                  <li>• Transparência nas relações</li>
                  <li>• Valorização dos profissionais</li>
                  <li>• Responsabilidade social e ambiental</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="section-title">Por Que Escolher a GMAX?</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Entenda os diferenciais que fazem da GMAX Soluções a escolha ideal para sua empresa.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all">
              <div className="text-gmax-blue text-4xl mb-4">🚀</div>
              <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">Agilidade</h3>
              <p className="text-gray-600">
                Atendimento imediato às suas necessidades, com capacidade de mobilização rápida de equipes.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all">
              <div className="text-gmax-blue text-4xl mb-4">💼</div>
              <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">Profissionalismo</h3>
              <p className="text-gray-600">
                Equipes treinadas e qualificadas, com experiência comprovada em suas áreas de atuação.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all">
              <div className="text-gmax-blue text-4xl mb-4">💰</div>
              <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">Custo-Benefício</h3>
              <p className="text-gray-600">
                Preços competitivos sem comprometer a qualidade dos serviços prestados.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all">
              <div className="text-gmax-blue text-4xl mb-4">🔄</div>
              <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">Flexibilidade</h3>
              <p className="text-gray-600">
                Soluções personalizadas para atender às necessidades específicas da sua empresa.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gmax-blue text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Pronto para conhecer nossas soluções?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Entre em contato conosco e descubra como podemos ajudar sua empresa a otimizar a gestão de facilities.
          </p>
          <a href="/contato" className="bg-white text-gmax-blue font-semibold py-3 px-8 rounded-md hover:bg-opacity-90 transition-all duration-300 inline-block">
            Fale Conosco
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
